import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query Filter1NotEquippedUsageUnitsQuery(
    $companyId: ID!
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
  ) {
    Me {
      Company(id: $companyId) {
        data: UsageUnits(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $filters
          }
          context: RecentRegularAppointment
        ) {
          id
          lockPeriods(
            options: {
              startRow: 0
              endRow: 0
              sorting: { colId: "begin", sort: "DESC" }
              filters: [
                {
                  filterType: text
                  operator: AND
                  name: "status"
                  conditions: [{ type: equals, value: ["ACTIVE"] }]
                }
                {
                  filterType: text
                  operator: AND
                  name: "reason"
                  conditions: [
                    {
                      type: equals
                      value: [
                        "TEMP_FOR_RENOVATION"
                        "TEMP_FOR_CLEARIFICATION"
                        "CUSTOMER_TEMP_DEFERRED_INSTALLATION"
                      ]
                    }
                  ]
                }
              ]
            }
          ) {
            id
            begin
            status
            reason
          }
          appointments(
            options: {
              startRow: 0
              endRow: 0
              sorting: [{ colId: "date", sort: "DESC" }]
              filters: [
                {
                  filterType: text
                  operator: AND
                  name: "type"
                  conditions: [{ type: equals, value: ["T1", "T2", "TI"] }]
                }
              ]
            }
          ) {
            id
            type
            status
            accessReason
            executionDate
          }
          referenceNumber
          tableId
          address {
            city
            street
            number
          }
          tenants {
            id
            firstname
            lastname
          }
          registrations {
            id
            actionPosition {
              id
              name
            }
          }
          type
          billingPartitions {
            id
            name
          }
          CAN {
            one
            two
            three
            four
            five
          }
        }
      }
    }
  }
`
